import EntityActionButton from 'features/Entity/components/EntityActionBar/components/EntityActionButton';
import useStyles from 'features/Entity/components/EntityActionBar/EntityActionBar.styles';
import { ILiveEntity } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';
import { LiveStatus } from 'utils/statuses';

type EntityActionBarProps = {
  entity: ILiveEntity;
};

const EntityActionBar = ({ entity }: EntityActionBarProps) => {
  const classes = useStyles();
  const { spaceId, status, entityType } = entity;

  const isValidEntityType = (
    type: EntityType
  ): type is EntityType.FRAME | EntityType.LINKED_ASSET => {
    return type === EntityType.FRAME || type === EntityType.LINKED_ASSET;
  };

  const renderButtons = () => {
    if (!isValidEntityType(entityType)) {
      return null;
    }

    switch (status) {
      case LiveStatus.ACTIVE:
        return <EntityActionButton spaceId={spaceId} entityType={entityType} action="deactivate" />;
      case LiveStatus.INACTIVE:
        return (
          <>
            <EntityActionButton spaceId={spaceId} entityType={entityType} action="activate" />
            <EntityActionButton spaceId={spaceId} entityType={entityType} action="archive" />
          </>
        );
      case LiveStatus.ARCHIVED:
        return <EntityActionButton spaceId={spaceId} entityType={entityType} action="unarchive" />;
      default:
        return null;
    }
  };

  return <div className={classes.root}>{renderButtons()}</div>;
};

export default EntityActionBar;
